import React from "react";
import gears from "../../assets/images/gears.png";
import { LoggedInPageTemplate } from "../../core/layout/LoggedInPageTemplate"
import UsersListingContainer from "./components/UsersListingContainer";
import { strings } from "../../content/strings";

const UsersListingPage = () => {
    return (
        <LoggedInPageTemplate
            backgroundImage={gears}
            pageTitle={strings.users}
            pageDescription=""
            pageCanonical="www.davincilock.com/UsersListing_Locks/SerialCodeListingByCompany">
            <UsersListingContainer />
        </LoggedInPageTemplate >
    );
};

export default UsersListingPage;
